module.exports = __webpack_public_path__ + "static/img/5754.37d44aed.png";